/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
var formHeaderContentStyles = xcss({
  minWidth: '100%',
  marginBlockStart: 'space.100'
});
var formHeaderDescriptionStyles = xcss({
  marginBlockStart: 'space.100'
});

/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */
var FormHeader = function FormHeader(_ref) {
  var children = _ref.children,
    description = _ref.description,
    title = _ref.title;
  return jsx(Box, null, title && jsx(Heading, {
    size: "large"
  }, title), description && jsx(Box, {
    xcss: formHeaderDescriptionStyles
  }, description), children && jsx(Box, {
    xcss: formHeaderContentStyles
  }, children));
};
export default FormHeader;